module.exports = __webpack_public_path__ + "img/1791993042446.c37a5568.png";